const PATHS: Record<string, string> = {
  till: "M3 7h18v12H3zM7 7V4h10v3M7 12h4M7 15h2",
  dash: "M4 13h6V4H4zM14 20h6v-9h-6zM14 4h6v4h-6zM4 20h6v-4H4z",
  report: "M5 20V10M12 20V4M19 20v-7",
  box: "M3 8l9-5 9 5v8l-9 5-9-5zM3 8l9 5 9-5M12 13v8",
  truck: "M3 6h11v10H3zM14 10h4l3 3v3h-7M5 18a2 2 0 104 0 2 2 0 10-4 0M15 18a2 2 0 104 0 2 2 0 10-4 0",
  team: "M6 8a3 3 0 106 0 3 3 0 10-6 0M3 20c.8-3.5 3.2-5 6-5s5.2 1.5 6 5M16 5a3 3 0 010 6M21 20c-.4-2-1.4-3.4-3-4.2",
  gear: "M9 12a3 3 0 106 0 3 3 0 10-6 0M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4L7 17M17 7l1.4-1.4",
  lock: "M5 11h14v9H5zM8 11V8a4 4 0 018 0v3",
  search: "M4 11a7 7 0 1014 0 7 7 0 10-14 0M20 20l-3.5-3.5",
  scan: "M4 6v12M7 6v12M10 6v12M14 6v12M17 6v12M20 6v12",
  menu: "M4 7h16M4 12h16M4 17h16",
  chev: "M9 6l6 6-6 6",
  more: "M4 12h.01M12 12h.01M20 12h.01",
  x: "M6 6l12 12M18 6L6 18",
  cloud: "M7 18h10a4 4 0 00.5-8A6 6 0 006 9a4.5 4.5 0 001 9zM12 11v6M9 14l3-3 3 3",
  plus: "M12 5v14M5 12h14",
  label: "M3 5h11l7 7-7 7H3zM7 9h.01",
};

export function Icon({ name, size = 18, className }: { name: keyof typeof PATHS | string; size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={name === "more" ? 3 : 2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={className}>
      <path d={PATHS[name] ?? ""} />
    </svg>
  );
}
